import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { SHORTURL } from '../store/actionTypes';
import { ShortUrl, ShortUrlInput } from './models/shortUrl';

export const shortUrl = createApi({
  reducerPath: SHORTURL,
  baseQuery,
  tagTypes: ['ShortUrl'],
  endpoints: builder => ({
    shortUrl: builder.mutation<ShortUrl, ShortUrlInput>({
      query: variables => ({
        document: gql`
          mutation LinkMinifiers($linkMinifiersInput: MinifiedLinksInput!) {
            linkMinifiers(linkMinifiersInput: $linkMinifiersInput) {
              originalUrl
              domain
              shortUrl
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: { linkMinifiers: ShortUrl }) => response?.linkMinifiers,
    }),
  }),
});

export const { useShortUrlMutation } = shortUrl;
